<div class="wrapper content-wrapper row" style="background-color: #FFF;">
    <div class="col-md-12 col-12" *ngIf="showLevels" style="margin-top: 22px">
      <app-station-tank-levels [stations]="data" *ngIf="data"></app-station-tank-levels>
    </div>
  </div>
  
  <ng-template #selectionModalForDetails let-c="close" let-d="dismiss" class="modal-lg">
    <div class="modal-header" style="font-size: 10px !important;">
      <h5 class="modal-title">Stick Readings {{
        (selectedItem?.tblStations?.length > 0 && selectedItem.tblStations[0]?.lastPolled) ? ("for : " +
        selectedItem.tblStations[0]?.lastPolled) : " :"
        }}</h5>
      <button type="button" class="btn" (click)="openModalForGraph(selectionModalForGraph, item)">
  
        <span aria-hidden="true"><i class="fa fa-line-chart"></i></span>
      </button>
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  
    <div class="modal-content-cls" style="padding: 19px;">
      <div class="row">
        <div class="col-md-4 col-6">
          <p><b>ID: </b> {{selectedItem?.tblStations?.length > 0 && selectedItem.tblStations[0]?.locationID ?
            selectedItem.tblStations[0]?.locationID : ''}} / {{selectedItem?.tac}}</p>
        </div>
        <div class="col-md-4 col-6">
          <p style="position: absolute;"><b>Customer: </b>{{selectedItem?.billtype?.billingCodeName}}</p>
        </div>
        <div class="col-md-4 col-6">
          <b>Inv Group:</b>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 col-6">
          <p class="hidden-sm-up"><b>Phone:</b> {{selectedItem?.tblStations?.length > 0 &&
            selectedItem.tblStations[0]?.phone ? selectedItem.tblStations[0]?.phone : ''}}
        </div>
        <div class="col-md-4 col-6">
          <p style="position: absolute;"><b>Customer: </b>{{selectedItem?.billtype?.billingCodeName}}</p>
        </div>
        <div class="col-md-4 col-6">
          <p><b>Name:</b> {{selectedItem?.tblStations?.length > 0 && selectedItem.tblStations[0]?.name ?
            selectedItem.tblStations[0]?.name : ''}} </p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <p><b>City / State:</b> {{selectedItem?.tblStations?.length > 0 && selectedItem.tblStations[0]?.city ?
            selectedItem.tblStations[0]?.city : ''}} / {{selectedItem?.tblStations?.length > 0 &&
            selectedItem.tblStations[0]?.state ? selectedItem.tblStations[0]?.state : ''}}</p>
        </div>
        <div class="col-md-4 col-4">
          <b>
            <p class="hidden-xs-down">Phone: {{selectedItem?.tblStations?.length > 0 && selectedItem.tblStations[0]?.phone
              ? selectedItem.tblStations[0]?.phone : ''}}</p>
          </b>
        </div>
      </div>
  
      <div class="table-responsive" style="margin-top: 16px;">
        <table class="table table-striped">
          <thead style="background-color: #0cccbd">
            <tr>
              <th class="text-center">
                Tank ID
              </th>
              <th class="text-center">
                <b>Product </b>
              </th>
              <th class="text-center">
                <b>Date </b>
              </th>
              <th class="text-center">
                <b>Gallons </b>
              </th>
              <th class="text-center">
                <b>Ullage </b>
              </th>
              <th class="text-center">
                <b>Last Delivery </b>
              </th>
              <th class="text-center">
                <b>Tank Size </b>
              </th>
              <!-- <th class="text-center">
              <b>New Gallons </b>
            </th> -->
            </tr>
          </thead>
          <tbody [hidden]="!selectedItem">
            <tr [hidden]="!selectedItem" *ngFor="let item of selectedItem?.tblTanks; let i = index">
              <td [hidden]="!selectedItem" class="text-center">{{item?.counter}}</td>
              <td [hidden]="!selectedItem" class="text-center">{{item?.tankName}}</td>
              <td [hidden]="!selectedItem" class="text-center">{{item?.lastInventoryDate | date: 'MM/dd/yy HH:mm aa'}}
              </td>
              <td [hidden]="!selectedItem" class="text-center">{{item?.lastInventory}}</td>
              <td [hidden]="!selectedItem" class="text-center">{{item?.ullage}}</td>
              <td [hidden]="!selectedItem" class="text-center">{{item.lastDeliveryDate | date: 'MM/dd/yy HH:mm aa'}}</td>
              <td [hidden]="!selectedItem" class="text-center">{{item.tankSize}}</td>
              <!-- <td [hidden]="!selectedItem" class="text-center">
              <input type="text" placeholder="New Gallon" class="form-control" [(ngModel)]="tblReadings[i].gallons">
            </td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="table-responsive">
      <table class="table table-striped hidden-sm-up">
        <thead style="background-color: #0cccbd; color: #FFF;">
          <tr>
            <th style="" class="text-center">
              <b>Tank ID</b>
            </th>
            <th style="" class="text-center">
              <b>Product</b>
            </th>
            <th style="" class="text-center">
              <b>Gallons</b>
            </th>
          </tr>
        </thead>
  
        <tbody [hidden]="!selectedItem">
          <tr [hidden]="!selectedItem" *ngFor="let item of selectedItem?.tblTanks; let i = index">
            <td [hidden]="!selectedItem" class="text-center">{{item?.counter}}</td>
            <td [hidden]="!selectedItem" class="text-center">{{item?.tankName}}</td>
            <td [hidden]="!selectedItem" class="text-center">
              <input type="text" placeholder="New Gallon" [(ngModel)]="tblReadings[i].gallons" class="form-control">
            </td>
          </tr>
        </tbody>
      </table>
    </div> -->
    </div>
  
  
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
    </div>
  </ng-template>
  
  <ng-template #selectionModalForGraph let-c="close" let-d="dismiss" class="modal-lg">
    <div class="modal-header">
      Graph
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  
    <div style="display: block;">
      <canvas baseChart [datasets]="lineChartData" [labels]="lineChartLabels" [options]="lineChartOptions"
        [colors]="lineChartColors" [legend]="lineChartLegend" [chartType]="lineChartType" [plugins]="lineChartPlugins">
      </canvas>
    </div>
    <div class="chart-wrapper col-6">
  
    </div>
  
  
  
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
    </div>
  </ng-template>